/**
 * @generated SignedSource<<69ada7eb97d45d53f48c5a48de26694e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurrentEarningsCard_currentEarnings$data = {
  readonly amount: {
    readonly subUnitAmount: number;
  };
  readonly id: string;
  readonly " $fragmentType": "CurrentEarningsCard_currentEarnings";
};
export type CurrentEarningsCard_currentEarnings$key = {
  readonly " $data"?: CurrentEarningsCard_currentEarnings$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentEarningsCard_currentEarnings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./CurrentEarningsCardRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "CurrentEarningsCard_currentEarnings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "amount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "WalletBalance",
  "abstractKey": null
};

(node as any).hash = "31f3cfc4fa14ffb5a2053d7fc6b1c8ff";

export default node;
